import { Component, OnInit, HostListener } from '@angular/core';
import { ApiService } from '../../api.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  scrollY:number;
  mainWidth:number;
  headerHeight:number;

  displaySearch = false;
  searchForm:any = {};

  filteredGames:any;

  @HostListener('window:scroll', ['$event']) onScroll($event: Event): void {
    if($event && $event.target == document) {
      this.scrollY = window.scrollY;
      this.mainWidth = document.getElementById("main").offsetWidth;
    }
  }
  
  menu: any = [];
  account: any = [];

  constructor(public api:ApiService, private translateService: TranslateService) { }

  setMenu(){
    this.menu = [
      { icon: 'pi pi-home', routerLink: ['/'] },
      { label: 'Sorties', routerLink: ['/sorties'], visible: !this.api.export },
      {
        label: 'games',
        visible: !this.api.export,
        items: [
          { label: 'Tous nos jeux', routerLink: ['/games'] },
          /*{label:"Catalogue boutique",routerLink:["/games"], disabled:true},
        {label:"Catalogue GSS",routerLink:["/gss"]},
        {label:"Un jeu dans ma classe",routerLink:["/games"], disabled:true},*/
          {
            label: 'Catalogues pdf',
            routerLink: ['/catalogues'],
            disabled: false,
          },
          //{label:"Sélection du moment",routerLink:["/games"], disabled:true},
        ],
      },
      {
        label: 'Offres commerciales',
        routerLink: ['/offres-commerciales'],
        visible: this.api.pro && this.api.user.xx_Espace_Pro == 'gss',
      },
      {
        label: 'Actualités',
        visible:
          (this.api.user && this.api.user.xx_Espace_Pro != 'gss') ||
          this.api.export === false,
        items: [
          {
            label: 'Offres commerciales',
            routerLink: ['/offres-commerciales'],
            visible: this.api.pro,
          },
          { label: 'Les news', routerLink: ['/news'], visible: !this.api.pro },
          {
            label: 'Précommandes Essen',
            routerLink: ['/preorders-essen'],
            visible: !this.api.pro,
          },
          //{label:"Sélection du moment",routerLink:["/pages/test"], disabled:true},
          {
            label: 'Nos rendez-vous',
            routerLink: ['/rendez-vous'],
            disabled: false,
          },
          {
            label: 'Newsletters',
            routerLink: ['/newsletters'],
            disabled: false,
            visible: this.api.pro,
          },
        ],
      },
      {
        label: 'about-us',
        visible: !this.api.pro,
        items: [
          {
            label: 'Notre histoire',
            routerLink: ['/pages/notre-histoire'],
            visible: !this.api.export,
          },
          {
            label: "L'équipe",
            routerLink: ['/pages/lequipe'],
            disabled: false,
            visible: !this.api.export,
          },
          {
            label: "L'entrepôt",
            routerLink: ['/pages/nos-locaux'],
            disabled: false,
            visible: !this.api.export,
          },
          {
            label: 'The office',
            routerLink: ['/pages/the-office'],
            disabled: false,
            visible: this.api.export,
          },
          {
            label: 'Notre bilan RSE',
            routerLink: ['/bilan-rse'],
            disabled: false,
            visible: !this.api.export,
          },
        ],
      },
      { label: 'All Games', routerLink: ['/games'], visible: this.api.export },
      {
        label: 'Our publishers',
        routerLink: ['/editors'],
        visible: this.api.export,
      },
      { label: 'Contacts', routerLink: ['/contact'], visible: this.api.export },

      {
        label: 'Nos partenaires',
        visible: !this.api.pro && !this.api.export,
        items: [
          { label: 'Éditeurs', routerLink: ['/editeurs'] },
          { label: 'Boutiques', routerLink: ['/boutiques'] },
          {
            label: 'Un jeu dans ma classe',
            url: 'https://unjeudansmaclasse.com/',
          },
        ],
      },
      {
        label: 'Commande rapide',
        command: () => {
          this.api.goTo('commande');
          this.api.displayFast = true;
        },
        visible: this.api.pro,
      },
      {
        label: 'Contacts',
        visible: !this.api.pro && !this.api.export,
        items: [
          { label: 'SAV', routerLink: ['/sav'] },
          { label: 'Contactez-nous', routerLink: ['/contact'] },
        ],
      },
      {
        icon: 'pi pi-search',
        command: () => {
          this.displaySearch = true;
        },
        visible: false,
      },
    ];

    this.account = [
      {label: "Mon compte",routerLink:["/mon-compte"], icon: "pi pi-user"},
      {label: "Mes commandes",routerLink:["/mes-commandes"], icon: "pi pi-list"},
      {label: "Déconnexion", command: ()=>{
        localStorage.removeItem("EspaceProBlackrockUser");
        this.api.clearCart(true);
        this.api.goTo("login");
      }, icon: "pi pi-sign-out"}
    ];
  }

  ngOnInit(): void {
    this.scrollY = window.scrollY;
    const headerElement = document.getElementById('header');
    this.headerHeight = headerElement ? headerElement.offsetHeight : 0;
    this.filteredGames = this.api.games;
    setTimeout(()=>{  
      this.setMenu();
      this.menu.map((item) =>  item.label ? item.label = this.translateService.instant(item.label ) : null);
    },200);
  }

  logout(){

  }

  nbProds(){
    let uniq = [];
    for(let p of this.api.order.prods){
      uniq[p.Id] = p.Id;
    }
    return Object.values(uniq).length.toString();
  }

  filter(e){
    this.filteredGames = this.api.games.filter(item=>{
      return item.name.toLowerCase().indexOf(e.query.toLowerCase()) > -1;
    });
    this.searchForm.query = e.query;
  }

  search(){
    let query = this.api.returnBtoa(this.searchForm);
    this.api.goTo("games/"+query);
    this.searchForm.query = '';
    this.displaySearch = false;
  }
}
